let pushIsHandled = false;
// eslint-disable-next-line
window.handleOpenURL = function(url) {
    setTimeout(function () {
        console.log('handleOpenURL cordova-app: ' + url);
        if (url) url = url.replace('coral://', '/').replace('/web/', '/');
        if (!url || url === '/') url = '/home';
        if (url && url.indexOf('coupon=') > -1) {
            let coupon = url.split('coupon=');
            localStore.setItem('COUPON', coupon[1]);
            setTimeout(() => {
                window.app.$events.fire('user-save');
            }, 3000);
        }
        try {
            setTimeout(() => {
                if (url) {
                    localStore.removeItem('deeplink');
                    if (window.store.user.id) {
                        window.f7.views['main'].router.navigate(url, {
                            animate: false,
                            reloadAll: true
                        });
                    } else {
                        setTimeout(() => {
                            if (window.store.user.id) {
                                window.f7.views['main'].router.navigate(url, {
                                    animate: false,
                                    reloadAll: true
                                });
                            } else {
                                f7.toast
                                    .create({
                                        text: 'You must be logged in to use a deeplink',
                                        position: 'top',
                                        closeTimeout: 2000
                                    })
                                    .open();
                            }
                        }, 3000);
                    }
                    window.app.$events.fire('trackEvent', 'deeplink', 'deeplink', 0, url, {});
                }
            }, 1500);
        } catch (e) {
            console.error('Could not redir', e);
        }
    }, 10);
};

var cordovaApp = {
    f7: null,
    online: function () {
        console.log('Go Online');
        $$('#main').show();
        $$('#offline').hide();
        window.isOffline = false;
        f7.views['main'].router.refreshPage();
    },
    offline: function () {
        console.log('Go Offline');
        $$('#main').hide();
        $$('#offline').show();
        window.isOffline = true;
        f7.views['offline'].router.navigate('/offline', { reload: true, animatePages: false });
    },
    pause: function () {
        console.log('pause');
    },
    /*
    This method on resume
    */
    resume: function () {
        setTimeout(() => {
            console.log('resume');
            // do update stuff first
            let branch = localStore.getItem('branch') || '';
            let force = false;
            let setUpdate = () => {
                window.chcp.configure(
                    {
                        'config-file': `https://getcoral.s3.amazonaws.com/BUILDS${branch}/chcp.json`
                    },
                    error => {
                        if (error) {
                            console.log('Resume update error:', error.description);
                        } else {
                            if (branch || (!branch && force)) {
                                // imediate update because not prod or urgent
                                window.chcp.fetchUpdate(error => {
                                    if (!error) {
                                        window.chcp.installUpdate(() => {
                                            console.log('Update installed');
                                        });
                                    }
                                });
                            } else if (
                                localStore.getItem('hasUpdate') &&
                                localStore.getItem('jwt') &&
                                !localStore.getItem('deeplink')
                            ) {
                                localStore.removeItem('hasUpdate');
                                window.chcp.installUpdate(() => {
                                    console.log('Update installed');
                                });
                            } else {
                                console.log('Plugin configured successfully, getting updates');
                                window.chcp.fetchUpdate((error, data) => {
                                    if (error) {
                                        localStore.removeItem('hasUpdate');
                                        console.error(
                                            'Failed to load the update with error code: ' +
                                                error.code +
                                                ' ' +
                                                error.description
                                        );
                                    } else {
                                        console.log('Update is loaded', data);
                                        localStore.setItem('hasUpdate', 1);
                                    }
                                });
                            }
                        }
                    }
                );
            };
            if (branch) {
                // setTimeout(() => {
                //     alert(`On branch ${branch}`);
                // }, 1000);
                setUpdate();
            } else {
                // this is redudant but still
                // requires proxy due to cordova CORS
                window.app.$http.get('https://getcoral.app/api/services/chcp').then(
                    response => {
                        console.log('chcp', response.body);
                        if (response.body && response.body.update === 'now') force = true;
                        setUpdate();
                    },
                    response => {
                        console.error('chcp', response);
                        setUpdate();
                    }
                );
            }

            /// do notification stuff
            if (!localStore.getItem('notifications')) return;
            if (
                cordova.plugins &&
                cordova.plugins.notification &&
                cordova.plugins.notification.local
            ) {
                cordova.plugins.notification.badge.set(0);
            }

            // get chcp version
            window.chcp.getVersionInfo((err, data) => {
                console.log('Current version: ', data);
                localStore.setItem('chcpBuildNumber', data.currentWebVersion)
            })
        }, 100);
        // cordovaApp.branchSetup();
    },
    handleAppUpdate: function () {
        if (pgap) {
            if (localStore.getItem('branch')) {
                var branch =
                    localStore.getItem('branch') || (window.store.isTestflight ? 'DEV' : '');
                var options = {
                    'config-file': `https://getcoral.s3.amazonaws.com/BUILDS${branch}/chcp.json`
                };
                window.chcp.configure(options, function () {
                    document.addEventListener(
                        'chcp_updateIsReadyToInstall',
                        cordovaApp.onUpdateReady,
                        false
                    );
                    document.addEventListener(
                        'chcp_updateLoadFailed',
                        cordovaApp.onUpdateLoadError,
                        false
                    );
                });
                f7.toast
                    .create({
                        text: `Loaded ${branch} version`,
                        position: 'center',
                        closeTimeout: 3000
                    })
                    .open();
            } else {
                document.addEventListener(
                    'chcp_updateIsReadyToInstall',
                    cordovaApp.onUpdateReady,
                    false
                );
                document.addEventListener(
                    'chcp_updateLoadFailed',
                    cordovaApp.onUpdateLoadError,
                    false
                );
            }
        }
    },
    onUpdateReady: function () {
        // Illegal to have popup on iOS
        // f7.dialog.confirm(
        //     'New data is available!',
        //     () => {
        window.chcp.installUpdate(function (e) {
            console.log('install result', e);
        });
        //     },
        //     () => {
        //         // Cancel
        //     }
        // );
    },
    onUpdateLoadError: function (eventData) {
        var error = eventData.detail.error;
        if (error && error.code == window.chcp.error.APPLICATION_BUILD_VERSION_TOO_LOW) {
            console.log('Native side update required');
            var dialogMessage =
                'A new version of the application is available on the store and is required for some features to work properly. Please update, thank you!';
            window.chcp.requestApplicationUpdate(dialogMessage, () => {}, () => {});
        }
    },
    /*
  This method hides splashscreen after 2 seconds
  */
    handleSplashscreen: function (failsafe) {
        if (!window.navigator.splashscreen) return;
        setTimeout(
            () => {
                window.navigator.splashscreen.hide();
            },
            failsafe ? 4000 : 1500
        );
    },
    checkNativePerms: function () {
        if (typeof PushNotification === 'undefined') return;
        if (localStore.getItem('notifications')) {
            return;
        }
        window.PushNotification.hasPermission(function (data) {
            if (data.isEnabled) localStore.setItem('notifications', true);
            console.log(data, 'Notification permission status:');
            if (data.isEnabled)
                window.app.$events.fire('trackEvent', `notifications_enabled`, 'onboarding');
        });
    },
    handlePush: function () {
        if (pushIsHandled) return;
        pushIsHandled = true;
        console.log('handlepush');
        if (typeof window.PushNotification === 'undefined') return;
        window.phonegapPush = window.PushNotification.init({
            android: {},
            browser: {
                pushServiceURL: `https://getcoral.app/api/push`
            },
            ios: {
                alert: 'true',
                badge: 'true',
                sound: 'true'
            },
            windows: {}
        });

        window.phonegapPush.on('registration', data => {
            console.log('PUSH registration', data ? data.registrationId : data);
            if (data && data.registrationId) cordovaApp.checkNativePerms();
            if (!data.registrationId) return;
            window.app.$events.fire('userPushRegister', data);
            window.localStore.setItem('pushToken', data.registrationId);
            const d = new Date();
            const timezone = d.getTimezoneOffset() * 60;
            let device_type = 0;
            let platform = pgap
                ? device.platform || (window.f7.device.ios ? 'iOS' : 'Android')
                : 'web';
            if (platform === 'Android') device_type = 1;
            // REQUIRED The device's platform:
            // 0 = iOS
            // 1 = ANDROID
            // 2 = AMAZON
            // 3 = WINDOWSPHONE (MPNS)
            // 4 = CHROME APPS / EXTENSIONS
            // 5 = CHROME WEB PUSH
            // 6 = WINDOWS (WNS)
            // 7 = SAFARI
            // 8 = FIREFOX
            // 9 = MACOS
            // 10 = ALEXA
            // 11 = EMAIL
            setTimeout(() => {
                window.app.$http
                    .put('https://getcoral.app/api/devices', {
                        pushToken: data.registrationId,
                        timezone,
                        appVersion: window.version,
                        deviceType: platform,
                        device_type
                    })
                    .then(
                        response => {
                            console.log(response.body);
                        },
                        response => {
                            console.error(response);
                        }
                    );
            }, 5000);
        });

        window.phonegapPush.on('notification', data => {
            console.log('notification', data);
            //////////////////////////////////////////////////
            const { additionalData: { mp_ontap: onTap }} = data
            let url = ''
            if (!onTap) {
                url = '/home'
            } else if (onTap.type === 'homescreen') {
                url = '/home'
            } else if (onTap.type === 'deeplink') {
                // URL deeplink detects as coral:///units/201
                url = onTap.uri.replace('coral:///', '/')
            } else if (onTap.type === 'browser') {
                window.open(onTap.uri, '_system');
            }
            //////////////////////////////////////////////////
            // Reverting notification logic
            // let url =
            //     data.additionalData && data.additionalData.url ? data.additionalData.url : false;
            // if (
            //     data.additionalData &&
            //     data.additionalData.mp_ontap &&
            //     ['deeplink', 'homescreen'].indexOf(data.additionalData.mp_ontap.type) > -1 &&
            //     data.additionalData.mp_ontap.uri
            // ) {
            //     url = data.additionalData.mp_ontap.uri.replace('coral:///', '/');
            // }
            // if (
            //     data.additionalData &&
            //     data.additionalData.mp_ontap &&
            //     data.additionalData.mp_ontap.type === 'browser' &&
            //     data.additionalData.mp_ontap.uri
            // ) {
            //     url = false;
            //     window.open(data.additionalData.mp_ontap.uri, '_system');
            // }
            // alert('handleOpenURL 2: ' + data.additionalData.url);
            // data.title,
            // data.count,
            // data.sound,
            // data.image,
            // data.additionalData
            window.app.$events.fire(
                'trackEvent',
                `push_notification`,
                'push',
                0,
                data.title,
                data.additionalData
            );
            if (url) {
                localStore.setItem('deeplink', url);
                try {
                    setTimeout(() => {
                        if (localStore.getItem('deeplink')) {
                            if (window.store.user.id) {
                                window.f7.views['main'].router.navigate(url, {
                                    animate: false,
                                    reloadAll: true
                                });
                            } else {
                                setTimeout(() => {
                                    if (window.store.user.id) {
                                        window.f7.views['main'].router.navigate(url, {
                                            animate: false,
                                            reloadAll: true
                                        });
                                    } else {
                                        f7.toast
                                            .create({
                                                text: 'You must be logged in to use a deeplink',
                                                position: 'top',
                                                closeTimeout: 2000
                                            })
                                            .open();
                                    }
                                }, 3000);
                            }
                            window.app.$events.fire('deep-push', url);
                            localStore.removeItem('deeplink');
                        }
                    }, 1200);
                } catch (e) {
                    console.error('Could not redir', e);
                }
            }
            window.phonegapPush.finish(
                () => {
                    console.log('processing of push data is finished');
                },
                () => {
                    console.log(
                        'something went wrong with push.finish for ID =',
                        data.additionalData.notId
                    );
                },
                data.additionalData.notId
            );
        });

        window.phonegapPush.on('error', e => {
            console.error(e.message);
        });
    },
    handleAdjust: function () {
        if (window.AdjustConfig && window.Adjust) {
            var adjustConfig = new window.AdjustConfig(
                'x2wmb3c6f9j4',
                window.AdjustConfig.EnvironmentProduction
            );
            //  AdjustConfig.EnvironmentSandbox)

            adjustConfig.setLogLevel(window.AdjustConfig.LogLevelVerbose);
            // adjustConfig.setShouldLaunchDeeplink(true);
            // adjustConfig.setDelayStart(2.0);
            // adjustConfig.setSendInBackground(true);
            // adjustConfig.setEventBufferingEnabled(true);
            // adjustConfig.setDeviceKnown(true);
            // adjustConfig.setUserAgent("Custom Adjust User Agent");

            // adjustConfig.setAttributionCallbackListener(function (attribution) {
            //     console.log('[AdjustExample]: Attribution callback received.');
            //     console.log('[AdjustExample]: Tracker token = ' + attribution.trackerToken);
            //     console.log('[AdjustExample]: Tracker name = ' + attribution.trackerName);
            //     console.log('[AdjustExample]: Network = ' + attribution.network);
            //     console.log('[AdjustExample]: Campaign = ' + attribution.campaign);
            //     console.log('[AdjustExample]: Adgroup = ' + attribution.adgroup);
            //     console.log('[AdjustExample]: Creative = ' + attribution.creative);
            //     console.log('[AdjustExample]: Click label = ' + attribution.clickLabel);
            //     console.log('[AdjustExample]: Adid = ' + attribution.adid);
            // });

            // adjustConfig.setEventTrackingSucceededCallbackListener(function (eventSuccess) {
            //     console.log('[AdjustExample]: Event tracking succeeded callback received.');
            //     console.log('[AdjustExample]: Message: ' + eventSuccess.message);
            //     console.log('[AdjustExample]: Timestamp: ' + eventSuccess.timestamp);
            //     console.log('[AdjustExample]: Adid: ' + eventSuccess.adid);
            //     console.log('[AdjustExample]: Event token: ' + eventSuccess.eventToken);
            //     console.log('[AdjustExample]: Callback Id: ' + eventSuccess.callbackId);
            //     console.log('[AdjustExample]: JSON response: ' + eventSuccess.jsonResponse);
            // });

            // adjustConfig.setEventTrackingFailedCallbackListener(function (eventFailed) {
            //     console.log('[AdjustExample]: Event tracking failed callback received.');
            //     console.log('[AdjustExample]: Message: ' + eventFailed.message);
            //     console.log('[AdjustExample]: Timestamp: ' + eventFailed.timestamp);
            //     console.log('[AdjustExample]: Adid: ' + eventFailed.adid);
            //     console.log('[AdjustExample]: Event token: ' + eventFailed.eventToken);
            //     console.log('[AdjustExample]: Will retry: ' + eventFailed.willRetry);
            //     console.log('[AdjustExample]: Callback Id: ' + eventFailed.callbackId);
            //     console.log('[AdjustExample]: JSON response: ' + eventFailed.jsonResponse);
            // });

            // adjustConfig.setSessionTrackingSucceededCallbackListener(function (sessionSuccess) {
            //     console.log('[AdjustExample]: Session tracking succeeded callback received.');
            //     console.log('[AdjustExample]: Message: ' + sessionSuccess.message);
            //     console.log('[AdjustExample]: Timestamp: ' + sessionSuccess.timestamp);
            //     console.log('[AdjustExample]: Adid: ' + sessionSuccess.adid);
            //     console.log('[AdjustExample]: JSON response: ' + sessionSuccess.jsonResponse);
            // });

            // adjustConfig.setSessionTrackingFailedCallbackListener(function (sessionFailed) {
            //     console.log('[AdjustExample]: Session tracking failed callback received.');
            //     console.log('[AdjustExample]: Message: ' + sessionFailed.message);
            //     console.log('[AdjustExample]: Timestamp: ' + sessionFailed.timestamp);
            //     console.log('[AdjustExample]: Adid: ' + sessionFailed.adid);
            //     console.log('[AdjustExample]: Will retry: ' + sessionFailed.willRetry);
            //     console.log('[AdjustExample]: JSON response: ' + sessionFailed.jsonResponse);
            // });

            // adjustConfig.setDeferredDeeplinkCallbackListener(function (uri) {
            //     console.log('[AdjustExample]: Deferred Deeplink Callback received.');
            //     console.log('[AdjustExample]: URL: ' + uri);
            // });

            // window.Adjust.create(adjustConfig);
            setTimeout(() => {
                window.Adjust.getIdfa(function (idfa) {
                    // Use idfa value.
                    if (idfa && idfa !== '00000000-0000-0000-0000-000000000000')
                        window.localStore.setItem('idfa', idfa);
                });
                window.Adjust.getGoogleAdId(function (idfa) {
                    // Use idfa value.
                    if (idfa) window.localStore.setItem('googleAdId', idfa);
                });
                window.Adjust.getAdid(function (adid) {
                    // Use adid value.
                    if (adid) window.localStore.setItem('adjustAdId', adid);
                });
            }, 30);
        }
    },
    /*
  This method prevents back button tap to exit from app on android.
  And allows to exit app on backbutton double tap
  */
    handleAndroidBackButton: function () {
        cordovaApp.backButtonTimestamp = new Date().getTime();
        document.addEventListener(
            'backbutton',
            e => {
                if (new Date().getTime() - cordovaApp.backButtonTimestamp < 250) {
                    cordovaApp.backButtonTimestamp = new Date().getTime();
                    if (window.navigator.app && window.navigator.app.exitApp) {
                        // window.navigator.app.exitApp();
                    }
                    return true;
                } else {
                    // handle android back
                    if (f7.views['main'].router.currentRoute.path != '/home') {
                        f7.views['main'].router.back();
                    } else {
                        // navigator.app.exitApp();
                    }
                }
                cordovaApp.backButtonTimestamp = new Date().getTime();
                e.preventDefault();
                return false;
            },
            false
        );
    },
    /*
  This method does the following:
    - provides cross-platform view "shrinking" on keyboard open/close
    - hides keyboard accessory bar for all inputs except where it required
  */
    handleKeyboard: function () {
        if (!window.Keyboard || !window.Keyboard.shrinkView) return;
        var f7 = cordovaApp.f7;
        var $ = f7.$;
        window.Keyboard.shrinkView(false);
        window.Keyboard.disableScrollingInShrinkView(true);
        window.Keyboard.hideFormAccessoryBar(true);
        window.addEventListener('keyboardWillShow', () => {
            f7.input.scrollIntoView(document.activeElement, 0, true, true);
        });
        window.addEventListener('keyboardDidShow', () => {
            f7.input.scrollIntoView(document.activeElement, 0, true, true);
        });
        window.addEventListener('keyboardDidHide', () => {
            if (document.activeElement && $(document.activeElement).parents('.messagebar').length) {
                return;
            }
            window.Keyboard.hideFormAccessoryBar(false);
        });
        window.addEventListener('keyboardHeightWillChange', event => {
            var keyboardHeight = event.keyboardHeight;
            if (keyboardHeight > 0) {
                // Keyboard is going to be opened
                document.body.style.height = `calc(100% - ${keyboardHeight}px)`;
                $('html').addClass('device-with-keyboard');
            } else {
                // Keyboard is going to be closed
                document.body.style.height = '';
                $('html').removeClass('device-with-keyboard');
            }
        });
        $(document).on(
            'touchstart',
            'input, textarea, select',
            function (e) {
                var nodeName = e.target.nodeName.toLowerCase();
                var type = e.target.type;
                var showForTypes = ['datetime-local', 'time', 'date', 'datetime'];
                if (nodeName === 'select' || showForTypes.indexOf(type) >= 0) {
                    window.Keyboard.hideFormAccessoryBar(false);
                } else {
                    window.Keyboard.hideFormAccessoryBar(true);
                }
            },
            true
        );
    },
    fbSetup: function () {
        if (!window.facebookConnectPlugin) return;
        window.facebookConnectPlugin.activateApp(
            () => {
                console.log('facebookConnectPlugin activateApp OK');
                window.facebookConnectPlugin.getDeferredApplink(
                    link => {
                        console.log('facebookConnectPlugin getDeferredApplink OK', link);
                    },
                    () => {
                        console.log('facebookConnectPlugin getDeferredApplink Fail');
                    }
                );
            },
            () => {
                console.log('facebookConnectPlugin activateApp Fail');
            }
        );
    },
    branchSetup: function (isRetry) {
        if (!window.Branch) {
            if (!isRetry) {
                setTimeout(() => {
                    this.branchSetup(true);
                }, 3000);
            }
            return console.log('Branch not available');
        }
        console.log('Branch setup');
        // for development and debugging only
        window.Branch.setDebug(false);

        // for GDPR compliance (can be called at anytime)
        // window.Branch.disabledTracking(false);

        // for better Android matching
        window.Branch.setCookieBasedMatching('link.getcoral.app');

        // Apple search Ads support
        window.Branch.delayInitToCheckForSearchAds(true);

        // Branch initialization
        window.Branch.initSession().then(data => {
            try {
                if (data && data['+clicked_branch_link']) {
                    console.log('Open app with a Branch deep link: ' + JSON.stringify(data));
                    // Branch quick link: https://cordova.app.link/uJcOH1IFpM
                    // Branch web link: https://cordova-alternate.app.link/uJcOH1IFpM
                    // Branch dynamic link: https://cordova.app.link?tags=one&tags=two&tags=three&channel=Copy&feature=onboarding&stage=new+user&campaign=content+123+launch&type=0&duration=0&source=android&data
                    // Branch uri scheme: branchcordova://open?link_click_id=link-500015444967786346
                    // Branch android intent: intent://open?link_click_id=518106399270344237#Intent;scheme=looprocks;package=com.eneff.branch.cordovatestbed;S.browser_fallback_url=https%3A%2F%2Fcordova.app.link%2FuJcOH1IFpM%3F__branch_flow_type%3Dchrome_deepview%26__branch_flow_id%3D518106399312287278;S.market_referrer=link_click_id-518106399270344237%26utm_source%3DCopy%26utm_campaign%3Dcontent%20123%20launch%26utm_feature%3Donboarding;S.branch_data=%7B%22~feature%22%3A%22onboarding%22%2C%22this_is%22%3A%22true%22%2C%22custom_string%22%3A%22data%22%2C%22testing%22%3A%22123%22%2C%22%24publicly_indexable%22%3A%22false%22%2C%22%24desktop_url%22%3A%22http%3A%2F%2Fwww.example.com%2Fdesktop%22%2C%22%24one_time_use%22%3Afalse%2C%22custom_object%22%3A%22%7B%5C%5C%5C%22random%5C%5C%5C%22%3A%5C%5C%5C%22dictionary%5C%5C%5C%22%7D%22%2C%22~id%22%3A%22517795540654792902%22%2C%22~campaign%22%3A%22content%20123%20launch%22%2C%22%2Bclick_timestamp%22%3A1524764418%2C%22%2Burl%22%3A%22https%3A%2F%2Fcordova.app.link%2FuJcOH1IFpM%22%2C%22custom_boolean%22%3A%22true%22%2C%22custom%22%3A%22data%22%2C%22source%22%3A%22android%22%2C%22%24og_image_url%22%3A%22http%3A%2F%2Florempixel.com%2F400%2F400%2F%22%2C%22%2Bdomain%22%3A%22cordova.app.link%22%2C%22custom_integer%22%3A%221524690301794%22%2C%22~tags%22%3A%5B%22one%22%2C%22two%22%2C%22three%22%5D%2C%22custom_array%22%3A%22%5B1%2C2%2C3%2C4%2C5%5D%22%2C%22~channel%22%3A%22Copy%22%2C%22~creation_source%22%3A2%2C%22%24canonical_identifier%22%3A%22content%2F123%22%2C%22%24og_title%22%3A%22Content%20123%20Title%22%2C%22%24og_description%22%3A%22Content%20123%20Description%201524690296449%22%2C%22%24identity_id%22%3A%22453670943617990547%22%2C%22~stage%22%3A%22new%20user%22%2C%22%2Bclicked_branch_link%22%3Atrue%2C%22%2Bmatch_guaranteed%22%3Atrue%2C%22%2Bis_first_session%22%3Afalse%7D;B.branch_intent=true;end
                    // Branch android app link (device controlled): https://cordova.app.link/uJcOH1IFpM
                    // Branch ios universal link (device controlled): https://cordova.app.link/uJcOH1IFpM

                    let url = '';
                    let canonicalUrlPrefix = 'https://getcoral.app/web'
                    if (data['$deeplink_path']) {
                        // ideally $deeplink_path should be set with a preceding slash '/' in Branch
                        url = data['$deeplink_path'].charAt(0) === '/' ? data['$deeplink_path'] : `/${data['$deeplink_path']}`
                    } else if (data['$canonical_url']) {
                        // in case $deeplink_path is omitted, extract deeplink url from $canonical_url, which would always be present (eg. https://getcoral.app/web/units/3452)
                        url = data['$canonical_url'].replace(canonicalUrlPrefix, '')
                    }

                    if (url.indexOf('coupon=') > -1) {
                        let coupon = url.split('coupon=');
                        localStore.setItem('COUPON', coupon[1]);
                        setTimeout(() => {
                            window.app.$events.fire('user-save');
                        }, 3000);
                    }
                    if (url.indexOf('invite=') > -1) {
                        let invite = url.split('invite=');
                        localStore.setItem('INVITE', invite[1]);
                        setTimeout(() => {
                            window.app.$events.fire('user-save');
                        }, 5000);
                    }
                    localStore.setItem('deeplink', url);
                    setTimeout(() => {
                        window.app.$events.fire('deeplink', data, url);
                        console.log('load deeplink url', url);
                        if (url) {
                            window.f7.views['main'].router.navigate(url, {
                                reloadAll: true,
                                animate: false
                            });
                            localStore.removeItem('deeplink');
                        }
                        window.app.$events.fire(
                            'trackEvent',
                            'deeplink_branch',
                            'deeplink',
                            0,
                            url,
                            data
                        );
                        if (window.Adjust) window.Adjust.appWillOpenUrl(url);
                    }, 3000);
                } else if (data && data['+non_branch_link']) {
                    console.log('Open app with a non Branch deep link: ' + JSON.stringify(data));
                    // Competitor uri scheme: anotherurischeme://hello=world
                    let url = data['+non_branch_link'] || '';
                    if (url) url = url.replace('coral://', '').replace('/web/', '/');
                    if (url.indexOf('coupon=') > -1) {
                        let coupon = url.split('coupon=');
                        localStore.setItem('COUPON', coupon[1]);
                        setTimeout(() => {
                            window.app.$events.fire('user-save');
                        }, 3000);
                    }
                    if (url.indexOf('invite=') > -1) {
                        let invite = url.split('invite=');
                        localStore.setItem('INVITE', invite[1]);
                        setTimeout(() => {
                            window.app.$events.fire('user-save');
                        }, 5000);
                    }
                    localStore.setItem('deeplink', url);
                    setTimeout(() => {
                        if (localStore.getItem('deeplink')) {
                            window.f7.views['main'].router.navigate(url, {
                                reloadAll: true,
                                animate: false
                            });
                            localStore.removeItem('deeplink');
                        }
                        window.app.$events.fire(
                            'trackEvent',
                            'deeplink_non_branch',
                            'deeplink',
                            0,
                            url,
                            data
                        );
                        if (window.Adjust) window.Adjust.appWillOpenUrl(url);
                        window.app.$events.fire('deeplink', data, url);
                    }, 3000);
                } else {
                    console.log('Open app organically', data);
                    // if (window.Adjust) window.Adjust.appWillOpenUrl('/');
                    // window.app.$events.fire('trackEvent', 'deeplink_organic', 'deeplink', 0, 'organic');
                    // Clicking on app icon or push notification
                }
            } catch (e) {
                console.log('Branch deeplink error', e);
            }
        });
    },
    init: function (f7) {
        console.log('init');
        try {
            document.addEventListener(
                'deviceready',
                () => {
                    try {
                        window.Sentry = cordova.require('sentry-cordova.Sentry');
                        window.Sentry.init({
                            dsn: 'https://b860283cf3654248a842d9265a9aea4a@sentry.io/1820628'
                        });
                        if (window.version) window.Sentry.setRelease(window.version);
                        window.Sentry.configureScope(scope => {
                            scope.setTag(
                                'environment',
                                localStore.getItem('branch') || 'production'
                            );
                        });
                    } catch (e) {
                        console.log('could not init sentry', e);
                    }


                    // if (window.plugins && window.plugins.idfa && window.tapstream) {
                    //     window.plugins.idfa.getInfo().then(function(info) {
                    //         if (!info.limitAdTracking) {
                    //             console.log("apple ios", info.idfa);
                    //             console.log("android",  info.aaid);

                    //             window.tapstream.create('coral', '3g0Cq5HsSLe72mEv0hps_g', {
                    //                 idfa: info.idfa,
                    //                 collectDeviceId: true,
                    //                 collectWifiMac: false,
                    //             });
                    //         }
                    //     });
                    // }

                    if (window.tapstream) {
                        console.log("Loading tapstream");
                        window.tapstream.create('coral', '3g0Cq5HsSLe72mEv0hps_g', {});
                    }


                    if (window.plugins && window.plugins.appsFlyer && window.Purchases) {
                        const options = {
                            devKey: 'gHKjvmin4acdfdpQdT64p7',
                            isDebug: true,
                            onInstallConversionDataListener: true,

                        };

                        const userAgent = window.navigator.userAgent.toLowerCase();

                        if (/iphone|ipad|ipod/.test(userAgent)) {
                            options.appId = '1448861466'; // your ios app id in app store
                        }

                        window.plugins.appsFlyer.initSdk(
                            options,
                            (result) => {
                              console.log("Initializing appsFlyer");
                              // as of AppsFlyer plugin v4.4.22, result is stringified and must be parsed before sending to RevenueCat
                              const parsedResult = JSON.parse(result);



                              window.plugins.appsFlyer.getAppsFlyerUID(function(appsFlyerUID) {
                                console.log("Getting appsFlyerUID", appsFlyerUID)
                                window.Purchases.addAttributionData(parsedResult.data, window.Purchases.ATTRIBUTION_NETWORKS.APPSFLYER, appsFlyerUID)
                              });

                            },
                            error => {
                                console.error(error);
                            }
                        );
                    }

                    if (cordova.plugins && cordova.plugins.SmartlookPlugin) {
                        if (!localStore.getItem('isAdmin')) {
                            cordova.plugins.SmartlookPlugin.setupAndStartRecording({
                                smartlookAPIKey:
                                    TFDetect && TFDetect.isTFXC
                                        ? '8ab49ca3217abcbcc4377fcb1b840353812d9458'
                                        : '1b4dd0eff889587ddeb8c7ffe34c94ab284a3287'
                            });
                        }
                    }

                },
                false
            );
        } catch (e) {
            console.log('Could not init sentry');
        }
        document.addEventListener('deviceready', cordovaApp.handleSplashscreen, false);
        if (localStore.getItem('notifications')) {
            document.addEventListener('deviceready', cordovaApp.handlePush, false);
        } else {
            window.app.$events.on('push-setup', () => {
                console.log('push-setup-event');
                cordovaApp.handlePush();
            });
        }
        window.app.$events.on('push-check', () => {
            console.log('push-check-event');
            cordovaApp.checkNativePerms();
        });
        document.addEventListener('online', cordovaApp.online, false);
        document.addEventListener('offline', cordovaApp.offline, false);
        document.addEventListener('pause', cordovaApp.pause, false);
        document.addEventListener('resume', cordovaApp.resume, false);
        setTimeout(cordovaApp.resume, 10); // also fire resume on start

        document.addEventListener('deviceready', cordovaApp.branchSetup, false);
        document.addEventListener('resume', cordovaApp.branchSetup, false);

        document.addEventListener('deviceready', cordovaApp.fbSetup, false);
        document.addEventListener('resume', cordovaApp.fbSetup, false);

        document.addEventListener('deviceready', cordovaApp.handleAdjust, false);

        // Save f7 instance
        cordovaApp.f7 = f7;

        // Handle Android back button
        cordovaApp.handleAndroidBackButton();

        // Handle Statusbar
        cordovaApp.handleSplashscreen(true);

        // Handle Keyboard
        cordovaApp.handleKeyboard();

        // InappBrowser
        if (cordova && cordova.InAppBrowser) {
            window.open = cordova.InAppBrowser.open;
        }

        // Badge set to zero on open
        if (cordova.plugins && cordova.plugins.notification && cordova.plugins.notification.local) {
            // dont do before permission asked
            if (!localStore.getItem('notifications-push')) return;
            cordova.plugins.notification.badge.set(0);
        }
    }
};
export default cordovaApp;
